import {
  doc,
  onSnapshot,
  FirestoreError,
  Unsubscribe,
} from "firebase/firestore";
import { db } from "../../firebase";
import { EntityGet, EntityServerGet, OnSnapshotDocService } from "../../types";
import { Externalautomation } from "./types";
import { transformMetadata, processTimestampFields } from "../../utils";

export type ExternalautomationOnSnapshotDocService<T> = (
  agentId: string,
  id: string,
  callback: (doc: T) => void,
  onError?: (error: FirestoreError) => void
) => Unsubscribe;

const onSnapshotDoc: ExternalautomationOnSnapshotDocService<
  EntityGet<Externalautomation>
> = (agentId, id, callback, onError) => {
  const docRef = doc(db, `/agent/${agentId}/externalautomation/${id}`);
  return onSnapshot(
    docRef,
    (docSnap) => {
      if (docSnap.exists()) {
        callback(
          processTimestampFields(
            transformMetadata(
              {
                ...docSnap.data(),
                id: docSnap.id,
              } as EntityServerGet<Externalautomation>,
              docSnap.metadata
            )
          ) as EntityGet<Externalautomation>
        );
      } else {
        onError?.({
          name: "FirestoreError",
          code: "not-found",
          message: `Document "${id}" was not found`,
        });
      }
    },
    onError
  );
};

export default onSnapshotDoc;
